import { extendTheme } from '@chakra-ui/react';
import { FONT_FAMILY } from '@/constants/default-props';
import { ASSET_PATTERN_COLOR, BG_COLOR, TEXT_COLOR } from '@/constants/colors';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: 'Playfair Display',
    subHeading: 'Playfair Display',
    body: 'Cormorant Upright',
    name: 'Cormorant Upright',

// hardcoded font family for qrcode purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '56px',
    subHeading: '21px',
    body: '18px',
    name: '48px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
    name: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': 'italic',
        '--fontItalic-subHeading': 'italic',
        '--fontItalic-body': '',
        '--fontItalic-name': '',
      },
    },
  },
  colors: {
    bgPrimary: 'rgba(81,88,52,1)',
    bgSecondary: 'rgba(225,170,114,1)',
    bgTertiary: 'rgba(225,170,114,1)',
    bgAlternative: 'rgba(240,240,240,1)',
    mainColorText: 'rgba(225,170,114,1)',
    secondaryColorText: 'rgba(240,240,240,1)',
    tertiaryColorText: 'rgba(225,170,114,1)',
    alternativeColorText: '#000',
    assetPatternColor: 'rgb(245, 240, 238)',

    transparent: 'transparent',
  },
};

export default extendTheme(theme);
